/**
 * O que a tela "Como funciona" desenha, a partir do mapa que o backend lê do código
 * (spec 2026-10-26-chamados-como-funciona §3). Puro: sem React, sem rede.
 */
import type { AbaDoFluxo, CaminhoDoFluxo, MapaDoFluxo } from '@/api/chamados'
import { STATUS_DO_CHAMADO } from '@/components/chamados/StatusBadge'

export type Visao = 'solicitante' | 'atendimento'

export const QUALQUER_ESTADO = '*'
export const ESTADO_ANTERIOR = 'anterior'

/** Um estado que, nesta aba, só sai pela outra aba (C3: `approved` → esteira de mudança). */
export interface Atalho { de: string; aba: AbaDoFluxo }

export interface FluxoVisivel {
  estados: string[]
  caminhos: CaminhoDoFluxo[]
  atalhos: Atalho[]
}

export const origens = (c: CaminhoDoFluxo): string[] => (Array.isArray(c.de) ? c.de : [c.de])

const ordem = (estado: string) => {
  const i = STATUS_DO_CHAMADO.indexOf(estado as (typeof STATUS_DO_CHAMADO)[number])
  return i < 0 ? STATUS_DO_CHAMADO.length : i
}

const visivel = (c: CaminhoDoFluxo, visao: Visao) =>
  visao === 'atendimento' || (c.publico === 'todos' && c.ator !== 'admin')

/** As saídas de um estado: as próprias e as "de qualquer estado aberto". */
export function saidasDe(estado: string, caminhos: CaminhoDoFluxo[], encerrados: string[]) {
  return caminhos.filter((c) =>
    origens(c).includes(estado) || (c.de === QUALQUER_ESTADO && !encerrados.includes(estado)))
}

export function filtrarPorVisao(mapa: MapaDoFluxo, visao: Visao, aba: AbaDoFluxo): FluxoVisivel {
  const outra: AbaDoFluxo = aba === 'atendimento' ? 'mudanca' : 'atendimento'
  const estados = [...mapa.abas[aba]].sort((a, b) => ordem(a) - ordem(b))
  const caminhos = mapa.caminhos.filter((c) => c.aba === aba && visivel(c, visao))
  const naOutra = mapa.caminhos.filter((c) => c.aba === outra && visivel(c, 'atendimento'))
  const atalhos = estados
    .filter((e) => !mapa.encerrados.includes(e))
    .filter((e) => !caminhos.some((c) => origens(c).includes(e)))
    .filter((e) => naOutra.some((c) => origens(c).includes(e)))
    .map((de) => ({ de, aba: outra }))
  return { estados, caminhos, atalhos }
}
